/**
 * Viewport-relative rather than a fixed height: the list has to stay inside the
 * shortest phone in landscape, where a rem cap tuned for portrait would run off
 * the bottom.
 */
export const MENU_MAX_HEIGHT = '60vh';
